import React from 'react';
import { motion } from 'framer-motion';
import { Battery, Clock, ShieldCheck } from 'lucide-react';
export function Transformation() {
  return <section className="w-full max-w-3xl mx-auto px-6 py-16 text-center" data-id="element-150">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-151">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6" data-id="element-152">
          Lo que cambia en la práctica
        </h2>
        <p className="text-xl text-gray-600 mb-12 max-w-xl mx-auto" data-id="element-153">
          No “te vuelves perfecto”. Te vuelves{' '}
          <span className="font-bold text-navy" data-id="element-154">consistente</span>.
          <br data-id="element-155" />Y la consistencia es lo que te regresa:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-156">
          {[{
          icon: Clock,
          label: 'Tiempo',
          color: 'text-blue-600'
        }, {
          icon: Battery,
          label: 'Energía',
          color: 'text-green-600'
        }, {
          icon: ShieldCheck,
          label: 'Control',
          color: 'text-navy'
        }].map((item, i) => <motion.div key={i} whileHover={{
          y: -5
        }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col items-center gap-4" data-id="element-157">
              <item.icon className={`w-12 h-12 ${item.color}`} strokeWidth={1.5} data-id="element-158" />
              <span className="font-serif font-bold text-xl text-gray-800" data-id="element-159">
                {item.label}
              </span>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}